<template>
	<div class="form-background max-width-750">
		<Form
			:model="formState"
			name="basic"
			:label-col="{ span: 8 }"
			:wrapper-col="{ span: 16 }"
			:colon="false"
			autocomplete="off"
		>
			<FormItem
				:label="$t('account.fields.oldPassword')"
				v-bind="validateInfos.oldPassword"
			>
				<InputPassword v-model:value="formState.oldPassword" @keyup.enter="onSubmit"/>
			</FormItem>

			<FormItem
				:label="$t('account.fields.password1')"
				v-bind="validateInfos.password1"
			>
				<InputPassword v-model:value="formState.password1" @keyup.enter="onSubmit"/>
			</FormItem>

			<FormItem
				:label="$t('account.fields.password2')"
				v-bind="validateInfos.password2"
			>
				<InputPassword v-model:value="formState.password2" @keyup.enter="onSubmit"/>
			</FormItem>
			<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }">
				<Button
				type="primary"
				@click.prevent="onSubmit"
				:loading="isLoading"
				>
					{{ $t('account.passwordButtonLabel') }}
				</Button>
			</FormItem>
		</Form>
	</div>
</template>

<script>
import { reactive, ref } from 'vue';
import { Button, Form, FormItem, InputPassword, message } from 'ant-design-vue';

const useForm = Form.useForm;

import { useI18n } from 'vue-i18n'

import Api from '@/api/Api';

import { showErrorMessage } from '@/components/common/errorMessage';

export default {
	components: {
		Button, Form, FormItem, InputPassword,
	},
	setup() {
		const { t } = useI18n();
		const formState = reactive({
			oldPassword: '',
			password1: '',
			password2: '',
		});
		const validatePass = async (_rule, value) => {
			if (value === '') {
				return Promise.reject(t('account.messages.repeatPassword'));
			}
			if (value !== formState.password1) {
				return Promise.reject(t('account.messages.checkPassword'));
			}
			return Promise.resolve();
		};
		const rulesRef = reactive({
			oldPassword: [{ required: true, message: t('account.messages.enterOldPassword') }],
			password1: [{ required: true, message: t('account.messages.enterNewPassword') }],
			password2: [{ validator: validatePass }],
		});
		const {
			validate,
			validateInfos,
		} = useForm(formState, rulesRef);
		const isLoading = ref(false);

		const onSubmit = () => {
			validate().then(() => {
				isLoading.value = true;
				Api.changePassword(
					formState.oldPassword,
					formState.password1,
					() => {
						isLoading.value = false;
						message.success(t('account.messages.passwordSuccess'));
					},
					error => {
						isLoading.value = false;
						let errors = error.response.data;
						if (errors) {
							showErrorMessage(errors);
						}
					},
				);
			}).catch(() => {
				isLoading.value = false;
			});
		};
		return {
			formState,
			validateInfos,
			onSubmit,
			isLoading,
		};
	},
}
</script>
